/* global localData */
if (document.querySelector('.sc-all-membership-list')) {
  const memberAll = (() => {
    const r = {
      button: document.querySelector('.all-membership-list .membership-filter__submit'),
      reset: document.querySelector('.all-membership-list .membership-filter__clear'),
      inputs: document.querySelectorAll('.all-membership-list input'),
      firstFilterText: document.querySelector('.all-membership-list').dataset.first,
      secondFilterText: document.querySelector('.all-membership-list').dataset.second,
      searchMember: () => {
        let res = '?';
        r.inputs.forEach((e) => {
          if (e.type === 'text' && e.value) {
            res += `search=${e.value}`;
          } else if (e.type === 'radio' && e.checked === true) {
            res += `&${e.dataset.type}=${e.id}`;
          }
        });
        window.location.href = (res.length > 1) ? localData.currentUrl + res : localData.currentUrl;
      },
      checkIfForClear: () => {
        r.inputs.forEach((e) => {
          if ((e.type === 'text' && e.value) || (e.type === 'radio' && e.checked === true)) {
            r.reset.hidden = false;
          }
        });
      },
      removeInputs: () => {
        r.inputs.forEach((e) => {
          if (e.type === 'text') {
            e.value = '';
            e.closest('.input-field').classList.remove('is-focused');
          } else if (e.type === 'radio') {
            e.checked = false;
            e.closest('.dropdown').classList.remove('is-selected');
            let text = r.firstFilterText;
            if (e.dataset.type === 'activity') {
              text = r.secondFilterText;
            }
            e.closest('.dropdown').querySelector('.dropdown__placeholder-text').innerHTML = text;
          }
        });
        r.reset.hidden = true;
      },
      initButtons: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.searchMember();
        });
        r.reset.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.removeInputs(e);
        });
        r.inputs.forEach((ev) => {
          if (ev.type === 'text') {
            ev.addEventListener('keyup', (e) => {
              r.checkIfForClear(e);
            });
          } else if (ev.type === 'radio') {
            ev.addEventListener('change', (e) => {
              r.checkIfForClear(e);
            });
          }
        });
      },
    };
    return {
      initialize: () => {
        r.initButtons();
      },
    };
  })();
  memberAll.initialize();
}
